import { Helmet } from 'react-helmet';
import { getBaseUrl } from '../utils/config';

const StructuredData = ({ type = "Organization", data = {} }) => {
  const baseUrl = getBaseUrl();
  
  const getOrganizationSchema = () => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Vithminds Technologies Private Limited",
    "alternateName": "Vithminds",
    "url": baseUrl,
    "logo": `${baseUrl}/vithminds-logo.svg`,
    "description": "AI-powered digital transformation solutions for Fortune 500 enterprises",
    "email": "info@vithminds.com",
    "telephone": "+91-7093694639",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Flat No 302 C Block, Vazhraa Vihhari Manikonda",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500089",
      "addressCountry": "IN"
    },
    "founder": {
      "@type": "Person",
      "name": "Potturu Swapna",
      "jobTitle": "Founder & CEO"
    },
    "sameAs": [
      "https://facebook.com/vithminds",
      "https://twitter.com/vithminds",
      "https://linkedin.com/company/vithminds",
      "https://instagram.com/vithminds",
      "https://youtube.com/@vithminds"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-7093694639",
      "contactType": "Customer Service",
      "email": "info@vithminds.com",
      "areaServed": "IN",
      "availableLanguage": ["English"]
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "17.385044",
        "longitude": "78.486671"
      }
    }
  });

  const getWebSiteSchema = () => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Vithminds Technologies",
    "url": baseUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${baseUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  });

  const getBreadcrumbSchema = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  });

  const getServiceSchema = () => ({
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Digital Transformation & AI Solutions",
    "provider": {
      "@type": "Organization",
      "name": "Vithminds Technologies Private Limited"
    },
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Digital Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI & Agentic AI Solutions"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Intelligent Automation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Data Analytics & Engineering"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Low-Code/No-Code Development"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Digital Ecosystem Services"
          }
        }
      ]
    }
  });

  const schemas = [];

  switch(type) {
    case "Organization":
      schemas.push(getOrganizationSchema(), getWebSiteSchema());
      break;
    case "Service":
      schemas.push(getServiceSchema());
      break;
    case "Breadcrumb":
      if (data.items) {
        schemas.push(getBreadcrumbSchema(data.items));
      }
      break;
    default:
      schemas.push(getOrganizationSchema());
  }

  return (
    <Helmet>
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredData;
